import { addDays, midnight, workedInRange } from './weeklySummary.mjs'

export function dailyPayDetails(entries, operatorId, week, now) {
  return Array.from({ length: 7 }, (_, i) => {
    const day = addDays(week, i), start = midnight(day), end = midnight(addDays(day, 1))
    const shifts = entries.filter(e => e.operatorId === operatorId && Date.parse(e.clockInAt) < Math.min(end, now) && (e.clockOutAt ? Date.parse(e.clockOutAt) : now) > start)
      .sort((a,b) => Date.parse(a.clockInAt) - Date.parse(b.clockInAt))
      .map(entry => ({ entry, ...workedInRange(entry, start, end, now), pauses: (entry.breaks || []).flatMap(p => {
        const from = Math.max(start, Date.parse(entry.clockInAt), Date.parse(p.startedAt)), to = Math.min(end, now, entry.clockOutAt ? Date.parse(entry.clockOutAt) : now, p.endedAt ? Date.parse(p.endedAt) : now)
        return to > from ? [{ ...p, duration: to - from }] : []
      }) }))
    return { day, shifts, workedMs: shifts.reduce((sum,s) => sum + s.workedMs, 0), breakMs: shifts.reduce((sum,s) => sum + s.breakMs, 0) }
  })
}
